import { render } from "./ClientsAndOffersView.vue?vue&type=template&id=6655279c"
import script from "./ClientsAndOffersView.vue?vue&type=script&lang=js"
export * from "./ClientsAndOffersView.vue?vue&type=script&lang=js"

import "./ClientsAndOffersView.vue?vue&type=style&index=0&id=6655279c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__